import { RootState } from "app/store";

export const selectHasError = (state: RootState) => state.optin.hasError;
